export default "__VITE_ASSET__CymXEqJo__"